module.exports = __webpack_public_path__ + "fonts/nuxt-fontagon-icon.0974536.eot";